<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card flat color="grey-lighten-4" class="d-flex flex-column">
      <!-- Toolbar -->
      <v-row align="center" class="pa-2">
        <v-btn icon variant="text" @click="rotateL">
          <v-icon>mdi-rotate-left</v-icon>
        </v-btn>
        <v-btn icon variant="text" @click="rotateR">
          <v-icon>mdi-rotate-right</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn class="ma-2" variant="outlined" icon color="red" @click="close">
          <v-icon large>mdi-close</v-icon>
        </v-btn>
      </v-row>

      <!-- Image -->
      <v-row>
        <v-col cols="12">
          <v-img
            v-if="source"
            :style="{ transform: `rotate(${rotation}deg)` }"
            :src="source"
            aspect-ratio="1"
            contain
            @mousemove="zoomIn"
            @mouseleave="zoomOut"
          >
            <template #placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey-lighten-5" />
              </v-row>
            </template>
          </v-img>
          <v-progress-circular v-else indeterminate color="grey-lighten-5" />
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import zoom from "../utils/zoom";

export default {
  data: () => ({
    dialog: false,
    source: null,
    rotation: 0,
  }),
  watch: {},
  methods: {
    open(img) {
      if (img.type === "string") {
        this.source = `${this.$serverUri}/images/?q=${img.data.image}`;
      } else if (img.type === "label") {
        this.source = `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${img.data}`;
      } else if (img.type === "dataUrl") {
        this.source = img.data;
      } else {
        this.source = null;
      }
      this.dialog = true;
    },
    rotateR() {
      this.rotation += 90;
      // this.$refs.image.forEach((image) => {
      //   image.style.transform = `rotate(${this.rotation}deg) scale(${this.zoomLevel})`;
      // });
    },
    rotateL() {
      this.rotation -= 90;
      // this.$refs.image.forEach((image) => {
      //   image.style.transform = `rotate(${this.rotation}deg) scale(${this.zoomLevel})`;
      // });
    },

    zoomIn(event) {
      zoom.zoomIn(2.4, event, this.rotation);
    },
    zoomOut(event) {
      zoom.zoomOut(event, this.rotation);
    },
    close() {
      this.source = null;
      this.dialog = false;
      this.rotation = 0;
      this.$emit("close");
    },
  },
};
</script>
